import { Button } from '@mantine/core';
import { AttachmentDisplay } from '@medplum-components/AttachmentDisplay/AttachmentDisplay';
import { Attachment, Reference } from '@medplum/fhirtypes';
import {
  AttachmentButton,
  ComplexTypeInputProps,
  killEvent,
} from '@medplum/react';
import { MouseEvent, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useAttachmentDisplayContext } from '../AttachmentDisplay/AttachmentDisplayContext';

export interface AttachmentInputProps
  extends ComplexTypeInputProps<Attachment> {
  readonly arrayElement?: boolean;
  readonly securityContext?: Reference;
  readonly onChange?: (value: Attachment | undefined) => void;
}

export function AttachmentInput(props: AttachmentInputProps): JSX.Element {
  const { t } = useTranslation(['common']);

  const [value, setValue] = useState(props.defaultValue);

  const { removeButton: removeButton } = useAttachmentDisplayContext();

  function setValueWrapper(newValue: Attachment | undefined): void {
    setValue(newValue);
    if (props.onChange) {
      props.onChange(newValue);
    }
  }

  if (value) {
    return (
      <>
        <AttachmentDisplay value={value} maxWidth={200} />
        {removeButton && (
          <Button
            disabled={props.disabled}
            onClick={(e: MouseEvent) => {
              killEvent(e);
              setValueWrapper(undefined);
            }}
          >
            {t('remove', { ns: 'common' })}
          </Button>
        )}
      </>
    );
  }

  return (
    <AttachmentButton
      disabled={props.disabled}
      securityContext={props.securityContext}
      onUpload={setValueWrapper}
    >
      {(props) => <Button {...props}>{t('upload', { ns: 'common' })}</Button>}
    </AttachmentButton>
  );
}
